export default {
    manufacturer_delete_title: "Delete Manufacturer",
    manufacturer_delete_success_message: "The manufacturer has been deleted",
    manufacturer_delete_message: "Are you sure you want to delete the manufacturer?",
    manufacturer_delete_general_error: "It was not possible to delete the manufacturer due to an error",
    manufacturer_delete_package_in_use_unit: "The manufacturer is linked to some units so it is not possible to delete it",
    manufacturer_delete_package_in_use_device_model: "The manufacturer is linked to some device models so it is not possible to delete it",
    manufacturer_delete_package_in_use_unit_type: "The manufacturer is linked to some unit types so it is not possible to delete it",
}